export enum ProfileRequestStatusEnum {
  INITIALIZED = 'INITIALIZED',
  AWAITING_VALIDATION = 'AWAITING_VALIDATION',
  VALIDATED = 'VALIDATED',
  REFUSED = 'REFUSED'
}
